import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FilterStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M20.25 4C20.25 3.86192 20.1381 3.75 20 3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V6.53125C3.75 6.60539 3.78289 6.67613 3.83984 6.72363L9.1709 11.166L9.29492 11.2803C9.57071 11.5592 9.74635 11.9242 9.79004 12.3174L10.5869 19.4912C10.6061 19.6641 10.7918 19.7652 10.9473 19.6875L13.1855 18.5664C13.2587 18.5298 13.3095 18.4599 13.3213 18.3789L14.2031 12.2725C14.2649 11.845 14.4826 11.4554 14.8145 11.1787L20.1602 6.72363C20.2171 6.67615 20.25 6.60543 20.25 6.53125V4ZM21.75 6.53125C21.75 7.05057 21.5191 7.54346 21.1201 7.87598L15.7744 12.3311C15.7391 12.3606 15.7129 12.3992 15.6982 12.4424L15.6875 12.4873L14.8057 18.5928C14.7238 19.1601 14.3698 19.6517 13.8574 19.9082L11.6191 21.0283C10.5302 21.5734 9.23041 20.8675 9.0957 19.6572L8.29883 12.4834C8.29171 12.4194 8.26052 12.3598 8.21094 12.3184L2.87988 7.87598C2.48089 7.54348 2.25 7.05061 2.25 6.53125V4C2.25 3.03351 3.03351 2.25 4 2.25H20C20.9665 2.25 21.75 3.03352 21.75 4V6.53125Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FilterStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FilterStrokeIcon;
